import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { PrimaryButton } from '@/components/common/Button/style';

import * as S from './style';

const CompleteFindId = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { member_id } = location.state as { member_id: string };

	return (
		<S.Page>
			<S.Container>
				<S.FormCard>
					<S.CompleteBody>
						<S.IconWrap aria-hidden>✓</S.IconWrap>
						<S.Title>
							{t('findId.complete.titlePrefix')} <strong>{member_id}</strong> {t('findId.complete.titleSuffix')}
						</S.Title>
					</S.CompleteBody>
					<S.FormActions>
						<PrimaryButton type="button" onClick={() => navigate('/auth/login', { replace: true })}>
							{t('common.actions.goToLogin')}
						</PrimaryButton>
					</S.FormActions>
				</S.FormCard>
			</S.Container>
		</S.Page>
	);
};

export default CompleteFindId;
